import React from 'react';
import { CustomColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';
import { UserRtfsKey, UserRtfsValue } from './rtfsComponents';

export const columnConfigs = [
	CustomColumn({
		title: 'RTFS Feature',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => data,
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<div
					className={css({
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						height: '100%',
						overflowY: 'scroll',
						flexWrap: 'wrap'
					})}>
					<UserRtfsKey data={value} />
				</div>
			);
		}
	}),
	CustomColumn({
		title: 'Value',
		minWidth: 400,
		maxWidth: 500,
		mapDataToValue: (data: any) => data,
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<div
					className={css({
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						height: '100%',
						overflowY: 'scroll',
						flexWrap: 'wrap'
					})}>
					<UserRtfsValue data={value} />
				</div>
			);
		}
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 500
	}
};
